export function isSafePropertyAssignmentKey(key: string) {
  const forbiddenKeys = ['__proto__', 'prototype', 'constructor'];
  if (forbiddenKeys.includes(key)) {
    console.error('Unsafe keys detected during insertion; these will be skipped to maintain data integrity.');
    return false;
  }
  return true;
}
